// extracted by mini-css-extract-plugin
export default {"cta":"qH-z","disabled":"rH-z"};